import styled from 'styled-components';

export const HomeBoxesSectionWrapper = styled.section``;
